import Active from "@src/icons/Active";
import Inactive from "@src/icons/Inactive";
import theme from "@src/theme";
import { type ReactElement } from "react";

interface StatusProps {
    isActivated: boolean;
}

export const Status = ({ isActivated }: StatusProps): ReactElement => {
    const color = isActivated ? theme.palette.success.main : theme.palette.text.disabled;

    return isActivated ? <Active htmlColor={color} /> : <Inactive htmlColor={color} />;
};
